<template lang="pug">
  .d-case
    img.top-img(src="~assets/case/06/img1.png")
    .content
      .case-num Vol.06
      .case-title 设计师爆改上海50㎡老房，示范小户型改造神操作
      .line1 50㎡的房子可以玩出啥花样？窝仔的设计师朋友周琴，居然打造出客厅、卧室、厨房、餐厅、阳台、书房、储物区7大功能区，而且几乎任何边角位置都被充分利用，简直堪比大户型！
      img.cont-img(src="~assets/case/06/img2.png")
      .cont-title 「背景信息」
      .line1 <span>关于屋主</span>设计师周琴，知性女汉子一枚。从业近10年，帮无数业主实现过家的样子，在设计自住房的时候，自然要好好玩上一把。一个手枪型、只有50㎡的上海老房，让她充分挑战了设计极限。
      .cont-title 「房子的基本信息」
      .line1
        <span>坐标：上海普陀</span>
        <span>户型：两室两厅</span>
        <span>使用面积：49㎡</span>
        <span>原始状态：80年代老房</span>
        <span>装修风格：现代轻奢</span>
      img.cont-img(src="~assets/case/06/img3.png")
      .line1 原始房型图长得像一把手枪，很多建于70、80年代的上海老房都有这个特点——没有厅。拿到房子以后，周琴首先想到就是按功能需求重新做空间划分。
      .cont-title 客厅 15.5㎡：将卧室一分为二变出厅
      .line1 北卧室和南卧室是连一长条的，原本的想法是把中间的墙拿掉，让客厅更大些，敲墙的时候发现是混凝土，就放弃了。
      img.cont-img(src="~assets/case/06/img4.png")
      .line1 所以现在看到的客厅，是从原来的卧室一分为二改造出来的，中间采用三联动移门＋窗帘作为隔断。白天可以将窗帘拉开，这样光可以透进来。
      img.cont-img(src="~assets/case/06/img5.png")
      .line1 电视墙一侧之前是通往餐厅的门洞，砌高60公分，让电视墙有了延伸，看起来客厅好像更大了。同时坐在客厅可透过门洞望向餐厅，两个空间有了联动，视觉上也更通透。
      img.cont-img(src="~assets/case/06/img6.png")
      .line1 小户型整体硬装比较简单，主要采用大量软装进行装饰。整体的风格复古、轻奢、有质感，墙上的画组合摆放，看似毫无章法又很和谐。
      img.cont-img(src="~assets/case/06/img7.png")
      .line1 复古绿沙发、实木电视柜和边柜，都是外形简洁、相对细腿儿的款，可以让空间看起来更大。
      img.cont-img(src="~assets/case/06/img8.png")
      .cont-title 卧室 8㎡：无靠背床节省空间
      .line1 从客厅延续到卧室的咖色硅藻泥墙，主要为了满足卧室的无靠背床。用硅藻泥做床头，相对涂料来说没那么脆弱，质感更好。
      img.cont-img(src="~assets/case/06/img9.png")
      .line1 中间拉上一条金色不锈钢U型槽，像精致的腰封。
      .line1 小窍门：施工顺序是先做墙面涂料，后做金线条，最后做硅藻泥。
      img.cont-img(src="~assets/case/06/img10.png")
      .line1 为了节省空间，床两侧没有设置常规的床头柜，而是摆了两张非常简单的角几，用来随手放东西。
      img.cont-img(src="~assets/case/06/img11.png")
      .line1 正对床是一面顶天立地的衣柜，门采用的是模压板材质，黑色长拉手，这样的处理可以弱化它在空间的存在感，看起来非常简约。
      img.cont-img(src="~assets/case/06/img12.png")
      .line1 衣柜尺寸经过缜密计算，柜体占据53公分，过道49公分，刚好方便走路。
      .line1 小窍门：做成开门的衣柜，更节省空间。如果做成移门，轨道需要8公分左右。
      img.cont-img(src="~assets/case/06/img13.png")
      .cont-title 阳台 4㎡：一个人的休闲区
      .line1 阳台也包含到卧室内，让空间看起来更大了。洗衣、晾衣和休闲娱乐，都可以在这里得到满足。
      .line1 小窍门：洗衣机上部分有一些管道，做了柜子即可收纳又可遮挡。
      img.cont-img(src="~assets/case/06/img14.png")
      .cont-title 餐厅 3.6㎡：卡座式设计更实用
      .line1 餐厅做成卡座式，更能节约空间，同样采用硅藻泥水泥漆做靠背。原木色餐桌可以打开，扩大后能有1.2*0.8米，足够三五朋友聚餐。
      img.cont-img(src="~assets/case/06/img15.png")
      .line1 周琴很喜欢墨绿色，家里无处不在的墨绿。餐厅内更是刷上一整面墨绿，复古又时尚。简单拉根绳，挂几张照片，充满温馨感。
      img.cont-img(src="~assets/case/06/img16.png")
      .line1 唯一的遗憾是灯被工人装错了位置，好在灯是可以上下调节的，所以不会碰头。
      .cont-title 厨房 2.8㎡：挑战史上最小厨房
      .line1 周琴笑称她家有“史上最小的厨房”。长度2.2米，宽度1.18米，煤气灶台面做了55公分，过道还留了63公分，下柜部分全部做了抽屉，比开门好用，收纳力很强大。
      img.cont-img(src="~assets/case/06/img17.png")
      .line1 如果是开门，基本上下柜只能设计2层，但是做抽屉，可以做3层。靠水槽边上，留了一块地方放松下的蒸烤一体机，当微波炉使用。
      img.cont-img(src="~assets/case/06/img18.png")
      .line1 厨房右边的三联动移门叠在一起刚好跟橱柜宽度一致，白色鱼骨砖颜值很高，但是缝隙很大，建议做美缝，否则后期油腻很难打理。
      img.cont-img(src="~assets/case/06/img19.png")
      .cont-title 卫生间 2㎡：向厨房借面积
      .line1 老榆木台面做的洗手盆，由于空间狭窄，台面厚度只有30厘米，所以做了台上盆＋墙排水＋墙出水，节约空间的同时，台盆下面也看不到难看的污水管，增加收纳空间。
      img.cont-img(src="~assets/case/06/img20.png")
      .cont-title 书房 8.4㎡：办公收纳两不误
      .line1 这是被保留最完整的一个空间，也是周琴平时待得最多的地方。
      img.cont-img(src="~assets/case/06/img21.png")
      .line1 灰色的墙面，用爱格板仿实木色作为整个台面，视觉高度统一，各种抽屉特别好用。
      img.cont-img(src="~assets/case/06/img22.png")
      .line1 因为没有玄关，鞋子不够放，这面柜子主要用来放包包，鞋子，以及一些杂物的。
      img.cont-img(src="~assets/case/06/img23.png")
      .cont-title 储物柜：小户型收纳实用方案
      .line1 厨房太迷你，所以冰箱是放过道这里的，比较遗憾的是门洞不一样高，因为上面有结构梁。
      img.cont-img(src="~assets/case/06/img24.png")
      .line1 冰箱周边定制了一组柜子，白色哑光模压材质，拉手用的是比较简洁的黑长拉手。对小户型来说非常实用。
      img.cont-img(src="~assets/case/06/img25.png")
      .line1 看完这个家，你还会觉得小户型不够用吗？窝仔反而觉得小而美，住起来更温馨了。
    img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")


</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  },
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-case
  width: 100%
  position: relative
  padding-top: 0.1px
  .top-img
    width: 100%
    position: absolute
    z-index: -1
  .content
    margin: r(869) auto 0
    width: r(1020)
    // height: r(300)
    background: #ffffff
    padding-top: 0.1px
    padding-bottom: r(350)
    .case-num
      margin: r(43) auto
      width: r(844)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #717273
      letter-spacing: 0
    .case-title
      margin: r(18) auto r(50)
      width: r(844)
      font-weight: bolder
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #070809
      line-height: r(60)
      font-weight: bolder
    .line1
      margin: r(30) auto
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #585858
      line-height: r(34)
      span
        display: block
        text-align: center
    .cont-img
      margin-top: r(60)
      width: 100%
    .cont-title
      margin-top: r(64)
      font-family: PingFangSC-Medium
      font-weight: bolder
      font-size: r(20)
      color: #070809
      text-align: center
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// case6.vue?2abdce4f